<template>
    <div class="clearfix w980">
        <div class="v100 weizhi fs12">
            首页 - 产品 - 应用酷（手机版）</div>
        <product-menu now="appcool" />
        <div class="v100 bigimg mt20">
            <img alt="应用酷（手机版）" src="@/assets/images/P7.jpg" />
            <div class="brand">
				<img src="@/assets/images/yyk.jpg" alt="应用酷（手机版）" height="75" width="121" />
			</div>
            <h1 style="display:block;position:absolute;left:-5999px">应用酷（手机版）</h1>
        </div>
        <div class="v100 gongneng">
            <dl>
                <img alt="应用酷（手机版），海量安卓热门游戏应用任您下载" class="fl" src="@/assets/images/Ray27.jpg" />
                <dt class="fr">海量安卓应用</dt>
                <dd class="fr">
                    海量安卓热门游戏应用任您下载</dd>
            </dl>
            <dl>
                <img alt="应用酷（手机版），精品应用游戏定期推荐,还有更多特色热门专题、资讯" class="fr" src="@/assets/images/Ray28.jpg" />
                <dt class="fl">精品特色专题</dt>
                <dd class="fl">
                    精品应用游戏定期推荐,还有更多特色热门专题、资讯</dd>
            </dl>
            <dl>
                <img alt="应用酷（手机版），为您手机应用提供升级功能,让您轻松升级手机应用" class="fl" src="@/assets/images/Ray29.jpg" />
                <dt class="fr">轻松升级应用</dt>
                <dd class="fr">
                    为您手机应用提供升级功能,让您轻松升级手机应用</dd>
            </dl>
            <dl>
                <img alt="应用酷（手机版），强大的本地应用安装卸载管理功能、搜索功能" class="fr" src="@/assets/images/Ray30.jpg" />
                <dt class="fl">强大卸载管理</dt>
                <dd class="fl">
                    强大的本地应用安装卸载管理功能、搜索功能</dd>
            </dl>
        </div>
    </div>

</template>

<script>
import ProductMenu from "@/components/function/ProductMenu";
export default {
  name: "appcool",
  components: {
    ProductMenu
  }
};
</script>



// WEBPACK FOOTER //
// src/components/function/appcool.vue